import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import ChoiceLock from './ChoiceLock';
import Choicefilling from './Choicefilling';
import ScrollButton from '../../Modules/Components/ScrollButton'
import PopModal from '../../Constant/Custom/Models/PopModal';
import Selectedchoice from './SelectedChoices';
import { AuthContext } from '../../Auth/AuthContext';
import { serverUrl } from '../../Constant/Static/config';

function CFHome() {
  const { auth } = useContext(AuthContext);
  const storedUser = auth.user;
  const [csrfToken, setCsrfToken] = useState('');
  const [enableRC, setEnableRC] = useState(false);

  const [isWantToPay, setIsWantToPay] = useState(false);
  const [isAlreadyPaid, setIsAlreadyPaid] = useState(true);
  const [paymentFormHtml, setPaymentFormHtml] = useState('');

  const [currentSection, setCurrentSection] = useState(
    parseInt(localStorage.getItem('currentSection'), 10) || 1
  );
  const [lockStatus, setLockStatus] = useState('N');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
  const [onConfirm, setOnConfirm] = useState(() => () => { });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);


  // useEffect(() => {

  //   // const fetchCsrfToken = async () => {
  //   //   try {
  //   //     const response = await axios.get(`${serverUrl}/api/csrf-token`, {
  //   //       withCredentials: true  // Ensure cookies are sent
  //   //     });
  //   //     setCsrfToken(response.data.csrfToken);  // Set CSRF token
  //   //   } catch (error) {
  //   //     console.error('Error fetching CSRF token:', error);
  //   //   }
  //   // };
  //   // fetchCsrfToken();
  //   const handleRightClick = (e) => {
  //       if (!enableRC) e.preventDefault();
  //     // alert("Right-click is disabled!");
  //   };

  //   document.addEventListener("contextmenu", handleRightClick);
  //   const handleKeyPress = (e) => {
  //     // Disable F12, Ctrl+Shift+I, and Ctrl+Shift+J
  //     if (
  //       e.keyCode === 123 || // F12 key
  //       (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) // Ctrl + Shift + J or I or C
  //     ) {
  //       e.preventDefault();
  //       // alert("Developer tools are disabled!");
  //     }

  //     if (e.key == "k") {
  //       setEnableRC(true)
  //     } else {
  //       setEnableRC(false)
  //     }
  //   };

  //   document.addEventListener("keydown", handleKeyPress);
  //   const handleResize = () => setWindowWidth(window.innerWidth);
  //   window.addEventListener('resize', handleResize);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleRightClick); // Cleanup right-click event
  //     document.removeEventListener("keydown", handleKeyPress); // Cleanup keydown event
  //     window.removeEventListener('resize', handleResize);
  //   }
  // }, [enableRC]);


  useEffect(() => {
    localStorage.setItem('currentSection', currentSection);
  }, [currentSection]);





  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        // Fetch lock status
        const lockResponse = await axios.post(
          `${serverUrl}/api/choicefilling/user/choices/checklockstatus`,
          { appNo: storedUser.appno },
          // {
          // headers: {
          // 'Content-Type': 'application/json',
          // 'CSRF-Token': csrfToken,
          // },
          // withCredentials: true,
          // }
        );
        // console.log('Lock Status Response:', lockResponse.data); 


        const newLockStatus = lockResponse.data.lockstatus || 'N';
        setLockStatus((prev) => {
          if (prev !== newLockStatus) {
            // console.log(`Updating lockStatus from ${prev} to ${newLockStatus}`);
            return newLockStatus;
          }
          return prev;
        });

        // Update currentSection if locked
        if (newLockStatus === 'L') {
          setCurrentSection((prev) => {
            if (prev !== 3) {
              // console.log('Setting currentSection to 3 due to locked status');
              return 3;
            }
            return prev;
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Failed to fetch lock status. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };

    if (storedUser?.appno) {
      fetchData();
    } else {
      console.warn('No appno available in storedUser');
      setError('User not authenticated');
      setIsLoading(false);
    }
  }, [storedUser?.appno]);


  const handleNext = () => setCurrentSection((prev) => prev + 1);
  const handlePrevious = () => setCurrentSection((prev) => prev - 1);

  const getCircleColor = (step) => {
    if (currentSection > step || (lockStatus === 'L' && step === 3)) return '#2E7D32';
    if (currentSection === step) return '#1565C0';
    return '#BDBDBD';
  };

  const isMobile = windowWidth <= 768;
  const isSmallMobile = windowWidth <= 480;

  const circleRadius = isMobile ? (isSmallMobile ? 1 : 1.2) : 1.5;
  const strokeWidth = isMobile ? '0.1' : '0.2';
  const fontSize = isMobile ? (isSmallMobile ? '1.1' : '1.3') : '1.5';
  const labelFontSize = isMobile ? (isSmallMobile ? '1.2' : '1.3') : '1.5';





  const initiatePayment = async () => {
    try {
      const response = await axios.post(`${serverUrl}/api/initiate-payment`,
        { appno: storedUser?.appno, community: "SC" }, // The student only Rs. 250 to be paid.So, we set the default community without considering the students community.
        {
          headers: {
            'CSRF-Token': csrfToken  // Use CSRF token
          },
          withCredentials: true
        }
      );

      setPaymentFormHtml(response.data);
      setTimeout(() => {
        const form = document.getElementById('billdesk-form');
        if (form) {
          form.submit(); // Trigger form submission
        }
      }, 100); // Slight delay to ensure the form is rendered
      // window.location.href = `https://www.paymentgateway.com?data=${formPayload}`;
    } catch (error) {
      console.error('Error initiating payment:', error);
    }
  };

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true  // Ensure cookies are sent
        });
        setCsrfToken(response.data.csrfToken);  // Set CSRF token
      } catch (error) {
        console.error('Error fetching CSRF token:', error);
      }
    };

    fetchCsrfToken();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(`${serverUrl}/api/cv/pay-check`,
          {
            appNo: storedUser.appno,
            mobile: storedUser.mobile,
            email: storedUser.email
          },
          {
            withCredentials: true,
            'X-CSRF-Token': csrfToken
          }
        );
        if (response.status === 200) {
          setIsWantToPay(response.data.wantToPay);
          setIsAlreadyPaid(response.data.alreadyPaid)
        }
      } catch (error) {
        console.log(error)
      }
    }
    fetchData();
  }, [csrfToken])


  if (isWantToPay) {
    return (

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', padding: '100px' }}>
        <div>
          <h6 style={{ textAlign: 'center', fontSize: '17px', color: 'red' }}><span style={{ fontSize: '20px' }}>*</span>{`Application fees partially paid.\n Proceed with balance payment of Rs.250/-. After completing the payment, proceed with the further process of counselling, For any query contact : 8438661191`}</h6>

          <div className="ProceedButton" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <button style={{ margin: "20px", backgroundColor: '#28a745', textAlign: "center" }} onClick={initiatePayment}>
              Proceed to Pay
            </button>
          </div>
        </div>
        {paymentFormHtml && (
          <div dangerouslySetInnerHTML={{ __html: paymentFormHtml }} />
        )}
      </div>
    )

  }

  return (
    <div
      className="section"
      style={{
        backgroundColor: '#f4f4f4',
        border: '1px solid #ccc',
        borderRadius: '4px',
        margin: 0,
        maxHeight: '88.9vh',
        overflowY: 'auto',
        position: 'relative',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      {isLoading && <div>Loading...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {!isLoading && !error && (
        <>
          <br />
          <div style={{ width: '100%', boxSizing: 'border-box' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 10"
              preserveAspectRatio="xMidYMid meet"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                marginLeft: isMobile ? '-30px' : '-140px',
              }}
            >
              <line
                x1="19"
                y1="5"
                x2="28"
                y2="5"
                stroke={currentSection >= 1 ? '#0CAFFF' : 'black'}
                strokeWidth={strokeWidth}
              />
              <circle
                cx="30"
                cy="5"
                r={circleRadius}
                stroke={getCircleColor(1)}
                strokeWidth={strokeWidth}
                fill={getCircleColor(1)}
              />
              <text
                x="30"
                y="5"
                textAnchor="middle"
                dominantBaseline="middle"
                fontWeight="700"
                fontSize={fontSize}
                fill="#fff"
              >

                {currentSection == 1 ? '1' : currentSection >= 1 ? '\u2713' : '1'}
              </text>
              <text
                x="30"
                y={isMobile ? '8.5' : '9'}
                textAnchor="middle"
                fontSize={labelFontSize}
                fontWeight="600"
              >
                Choice Filling
              </text>


              <line
                x1="32"
                y1="5"
                x2="58"
                y2="5"
                stroke={currentSection >= 2 ? '#0CAFFF' : 'black'}
                strokeWidth={strokeWidth}
              />
              <circle
                cx="60"
                cy="5"
                r={circleRadius}
                stroke={getCircleColor(2)}
                strokeWidth={strokeWidth}
                fill={getCircleColor(2)}
              />
              <text
                x="60"
                y="5"
                textAnchor="middle"
                dominantBaseline="middle"
                fontWeight="700"
                fontSize={fontSize}
                fill="#fff"
              >
                {currentSection === 2 ? '2' : currentSection >= 2 ? '\u2713' : '2'}
              </text>
              <text
                x="60"
                y={isMobile ? '8.5' : '9'}
                textAnchor="middle"
                fontSize={labelFontSize}
                fontWeight="600"
              >
                Selected Choice
              </text>

              <line
                x1="62"
                y1="5"
                x2="88"
                y2="5"
                stroke={(lockStatus === 'L' || currentSection === 3) ? '#0CAFFF' : 'black'}
                strokeWidth={strokeWidth}
              />
              <circle
                cx="90"
                cy="5"
                r={circleRadius}
                stroke={getCircleColor(3)}
                strokeWidth={strokeWidth}
                fill={getCircleColor(3)}
              />
              <text
                x="90"
                y="5"
                textAnchor="middle"
                dominantBaseline="middle"
                fontWeight="700"
                fontSize={fontSize}
                fill="#fff"
              >
                {currentSection < 4 || lockStatus != 'L' ? '3' : '\u2713'}
              </text>
              <text
                x="90"
                y={isMobile ? '8.5' : '9'}
                textAnchor="middle"
                fontSize={labelFontSize}
                fontWeight="600"
              >
                Lock Choices
              </text>

              <line
                x1="92"
                y1="5"
                x2="100"
                y2="5"
                stroke={(lockStatus === 'L' || currentSection === 3) ? '#0CAFFF' : 'black'}
                strokeWidth={strokeWidth}
              />
            </svg>
          </div>
          <br />
          <div
            style={{
              width: '100%',
              minHeight: '70vh',
              padding: isMobile ? '8px' : '10px',
              boxSizing: 'border-box',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {currentSection === 1 && <Choicefilling handleNext={handleNext} />}
            {currentSection === 2 && <Selectedchoice handleNext={handleNext} handlePrevious={handlePrevious} />}
            {currentSection === 3 && <ChoiceLock handlePrevious={handlePrevious} choiceLockStatus={lockStatus} />}
          </div>
        </>
      )}
      <div>
        <PopModal
          isOpen={isModalOpen}
          onConfirm={onConfirm}
          type={modalType}
        />
      </div>
      <ScrollButton />






    </div>
  );
}

export default CFHome;